// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { initAndGetAnalyticsSdk } from "@mmt/event-logger";
import { isPartnerGI } from "@tm/insurance/utils";

export const AnalyticsSdk = initAndGetAnalyticsSdk({
  org: isPartnerGI() ? "GI" : "MMT",
});
